module.exports = __webpack_public_path__ + "static/media/mac_osx.a2191924.svg";